import { axiosPost } from "./ajaxServices";
import {
  urlGetClubSite,
  urlSaveClubSite,
  urlGetClubHomepage,
  urlSaveClubHomepage,
  urlDeleteClubHomepage,
  urlGetSubdomainFiles,
} from "./CONSTANTS";

// Fetch single club_site row by club
export const apiGetClubSite = ({ token, club_id }) => {
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("club_id", club_id);
  return axiosPost(urlGetClubSite, params);
};

// Create/update club_site with optional logos (multipart)
export const apiSaveClubSite = ({ token, club_id, domain, site_title, site_subtitle, info_page, info_page_file, logo_left, logo_left_remove, logo_left_url, logo_right, logo_right_remove, logo_right_url, toolbar_enabled, toolbar_items, default_email_logo, homepage_type, homepage_hero_image, homepage_text }) => {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("club_id", club_id);
  formData.append("domain", domain);
  formData.append("site_title", site_title);
  if (site_subtitle !== undefined && site_subtitle !== null) {
    formData.append("site_subtitle", site_subtitle);
  }
  if (info_page !== undefined && info_page !== null) {
    formData.append("info_page", info_page);
  }
  if (info_page_file !== undefined && info_page_file !== null) {
    formData.append("info_page_file", info_page_file || "");
  }

  // Only append files if a File/Blob is provided; otherwise let backend keep existing value
  if (logo_left instanceof File || logo_left instanceof Blob) {
    formData.append("logo_left", logo_left);
  } else if (logo_left_remove) {
    formData.append("logo_left_remove", "1");
  }
  formData.append("logo_left_url", logo_left_url || "");
  if (logo_right instanceof File || logo_right instanceof Blob) {
    formData.append("logo_right", logo_right);
  } else if (logo_right_remove) {
    formData.append("logo_right_remove", "1");
  }
  formData.append("logo_right_url", logo_right_url || "");

  // Default email logo preference
  if (default_email_logo !== undefined) {
    formData.append("default_email_logo", default_email_logo || "");
  }

  // Homepage type + single homepage fields
  formData.append("homepage_type", homepage_type || "sections");
  if (homepage_hero_image instanceof File || homepage_hero_image instanceof Blob) {
    formData.append("homepage_hero_image", homepage_hero_image);
  }
  if (homepage_text !== undefined && homepage_text !== null) {
    formData.append("homepage_text", homepage_text || "");
  }

  // Toolbar fields
  if (toolbar_enabled !== undefined && toolbar_enabled !== null) {
    formData.append("toolbar_enabled", toolbar_enabled);
  }
  if (Array.isArray(toolbar_items)) {
    formData.append("toolbar_count", toolbar_items.length);
    toolbar_items.forEach((item, idx) => {
      formData.append(`toolbar_name_${idx}`, item.name || "");
      formData.append(`toolbar_page_${idx}`, item.pageFile || "");
      formData.append(`toolbar_content_type_${idx}`, item.contentType || "html");
      if (item.imageFile instanceof File || item.imageFile instanceof Blob) {
        formData.append(`toolbar_image_${idx}`, item.imageFile);
      } else if (item.imagePreview) {
        formData.append(`toolbar_image_url_${idx}`, item.imagePreview);
      }
      if (item.contentImageFile instanceof File || item.contentImageFile instanceof Blob) {
        formData.append(`toolbar_content_image_${idx}`, item.contentImageFile);
      } else if (item.contentImagePreview) {
        formData.append(`toolbar_content_image_url_${idx}`, item.contentImagePreview);
      }
    });
  }

  return axiosPost(urlSaveClubSite, formData);
};

// Fetch club_homepage rows for a club
export const apiGetClubHomepage = ({ token, club_id }) => {
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("club_id", club_id);
  return axiosPost(urlGetClubHomepage, params);
};

// Upsert a homepage row (supports file upload). Backend should name the file using club_id + "db-item-" + id.
export const apiSaveClubHomepage = ({ token, club_id, id, title, description, font_color, image, info_page_enabled, info_page_content, info_page_type, info_page_file }) => {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("club_id", club_id);
  if (id) formData.append("id", id);
  formData.append("title", title);
  if (description !== undefined && description !== null) {
    formData.append("description", description);
  }
  if (font_color) {
    formData.append("font_color", font_color);
  }
  if (image instanceof File || image instanceof Blob) {
    formData.append("image", image);
  }
  // Info page fields
  if (info_page_enabled !== undefined && info_page_enabled !== null) {
    formData.append("info_page_enabled", info_page_enabled);
  }
  if (info_page_content !== undefined) {
    formData.append("info_page_content", info_page_content || "");
  }
  if (info_page_type !== undefined) {
    formData.append("info_page_type", info_page_type || "custom");
  }
  if (info_page_file !== undefined) {
    formData.append("info_page_file", info_page_file || "");
  }
  return axiosPost(urlSaveClubHomepage, formData);
};

// Get list of HTML/PHP files in subdomain directory
// Pass an optional subfolder (e.g. "page") to list files inside /home/beclutch/{domain}/{subfolder}
export const apiGetSubdomainFiles = ({ token, domain, subfolder }) => {
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("domain", domain);
  if (subfolder) params.append("subfolder", subfolder);
  return axiosPost(urlGetSubdomainFiles, params);
};

export const apiDeleteClubHomepage = ({ token, club_id, id }) => {
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("club_id", club_id);
  params.append("id", id);
  return axiosPost(urlDeleteClubHomepage, params);
};
